import Fuse from "fuse.js";
import { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FilterToggle from "../../atoms/FilterToggle";

const MantenimientoFilter = ({ filters, options, setFilters, optionsStaff }) => {
    const [selectedInmuebles, setSelectedInmuebles] = useState([]);

    const handleDateRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            date_service: { start, end }
        }));
    };

    const handleReset = () => {
        setFilters({
            inmuebles: [],
            date_service: { start: null, end: null },
        });
        setSelectedInmuebles([]);
    };

    return (
        <FilterToggle>
            <div className="w-full flex flex-col">
                <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <Select
                            isMulti
                            name="inmuebles"
                            value={selectedInmuebles}
                            onChange={(selected) => {
                                setSelectedInmuebles(selected || []);
                                setFilters(prev => ({
                                    ...prev,
                                    inmuebles: selected?.map(sel => sel.value) || [],
                                }));
                            }}
                            options={options}
                            placeholder="Filtrar por inmueble(s)..."
                            className="w-full"
                            classNamePrefix="select"
                            filterOption={createFuseFilter(options, ["label"])}
                        />
                    </div>
                    <div>
                        <Select
                            name="staff"
                            value={optionsStaff?.find(s => s.value === filters.staff) || null}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    staff: selected ? selected.value : null,
                                }));
                            }}
                            options={optionsStaff}
                            placeholder="Filtrar por responsable..."
                            className="w-full"
                            classNamePrefix="select"
                            isClearable
                            filterOption={createFuseFilter(optionsStaff, ["label"])}
                        />
                    </div>
                    <input
                        type="text"
                        placeholder="Buscar por descripción..."
                        value={filters.description}
                        onChange={(e) =>
                            setFilters(prev => ({ ...prev, description: e.target.value }))
                        }
                        className="border border-gray-300 px-2 rounded w-full"
                    />
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.date_service.start}
                            endDate={filters.date_service.end}
                            onChange={handleDateRangeChange}
                            placeholderText="Rango de fecha"
                            className="border border-gray-300 px-2 py-[4.5px] rounded w-full min-w-0"
                            isClearable
                            dateFormat="dd/MM/yy"
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <button
                        onClick={handleReset}
                        className="text-gray-500 text-xs p-1"
                    >
                        Limpiar filtros
                    </button>
                </div>
            </div>
        </FilterToggle>
    );
};

export default MantenimientoFilter;

const createFuseFilter = (optionsList, keys) => {
    const fuse = new Fuse(optionsList, {
        keys,
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: false,
        useExtendedSearch: true,
    });

    return (candidate, input) => {
        if (!input) return true;
        const results = fuse.search(input);
        return results.some(res => res.item.value === candidate.value);
    };
};
